const dataJson = require('./config.json');
const host = "";

//http://127.0.0.1:

//helper functions for fetching from backend

// GET
export const get = (path, queryString) => {
  return new Promise((resolve, reject) => {
    fetch(host + path + '?' + queryString, {
      method: 'GET',
      // headers: {
      //   'Accept': 'application/json',
      // }
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          reject(data.error);
        } else {
          resolve(data);
        }
      });
  });
};

// POST
export const post = (path, queryString) => {
  return new Promise((resolve, reject) => {
    fetch(host + path + '?' + queryString, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      //body: JSON.stringify(body)
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          reject(data.error);
        } else {
          resolve(data);
        }
      });
  });
};

// DELETE
export const del = (path, queryString) => {
  return new Promise((resolve, reject) => {
    fetch(host + path + '?' + queryString, {
      method: 'DELETE',
      headers: {
        'Content-type': 'application/json',
      },
    })
    .then(() => {
      resolve();
    })
  });
};